import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

jQuery(document).ready(function($) {

/* ====================== DISPLAY HEIGHT VARS ======================  */
  if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && window.innerHeight > window.innerWidth) {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', vh+'px');
      document.documentElement.style.setProperty('--staticvh', vh+"px");
      window.addEventListener('resize', function() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh+'px');
      });
  }

/* ====================== ADD CLASS TO EMPTY P TAGS ======================  */
  document.querySelectorAll('p').forEach(p => {
    if (p.innerHTML.trim() === '&nbsp;') {
      p.classList.add('only-nbsp');
    }
  });

/* ====================== Initialize Fancybox as usual ======================  */
  Fancybox.bind("[data-fancybox]", {
      Toolbar: {
          display: {
              left: [],
              middle: ["prev", "infobar", "next"],
              right: ["flipX" , "fullscreen", "thumbs", "close"],
          },
      },
  });

/* ====================== SMOOTH SCROLL HASH LINKS ======================  */
    $('a[href*="#"]').on('click', function(event) {
        var targetId = $(this).attr('href').split('#')[1]; // Get the ID from the href
        var targetElement = $('#' + targetId); // Select the target element

        if (targetElement.length) { // Check if the element exists
            event.preventDefault(); // Prevent default anchor link behavior

          // Check if the clicked link is inside a nav
          if ($(this).closest('nav').length) {
              if($(window).width() <= 767) {
                $('.header').toggleClass('header--nav-open');
                $('.navigation').toggleClass('navigation--nav-open');
                $('html,body').toggleClass('noscroll');
              }
          }

            $('html, body').animate({
                scrollTop: targetElement.offset().top
            }, 800, 'swing'); // Smooth scroll animation
        }
    });

/* ====================== ADD CLASS TO EMPTY P TAGS ======================  */
  document.querySelectorAll('p').forEach(p => {
    if (p.innerHTML.trim() === '&nbsp;') {
      p.classList.add('only-nbsp');
    }
  });

    /* ====================== MOBILE NAV ======================  */
    function mobile_nav() {
        if($(window).width() <= 1025) {
          $('.header__nav-toggle').unbind().on("click", function() {
            $('.header').toggleClass('header--nav-open');
            $('.navigation').toggleClass('navigation--nav-open');
            $('html,body').toggleClass('noscroll');
          });
        }
    }

    mobile_nav();

/* ====================== WINDOW REISZE FUNCTION  ======================  */
  $(window).resize(function() {
    mobile_nav();
  })
});
